import type { StateCreator } from "zustand";

import type { UIState } from "./index";

export interface BucketEndWarningSlice {
  /**
   * Planned end (ms) whose warning was dismissed, per bucket id, in this tab. A later planned end
   * warns again. In memory only, so a reload resets it.
   */
  dismissedBucketEndWarnings: Record<number, number>;
  dismissBucketEndWarning: (bucketId: number, plannedEndMs: number) => void;
}

export const createBucketEndWarningSlice: StateCreator<UIState, [], [], BucketEndWarningSlice> = (set) => ({
  dismissedBucketEndWarnings: {},
  dismissBucketEndWarning: (bucketId, plannedEndMs) =>
    set((state) =>
      state.dismissedBucketEndWarnings[bucketId] === plannedEndMs
        ? state
        : { dismissedBucketEndWarnings: { ...state.dismissedBucketEndWarnings, [bucketId]: plannedEndMs } },
    ),
});
